import { Environment, ENVIRONMENTS } from 'shared/models/feature-flag';

export const getCurrentEnvironment = (): Environment => {
  const env = (import.meta.env.VITE_BUILD_ENVIRONMENT as string)?.toLowerCase() as Environment;

  if (!ENVIRONMENTS.includes(env)) {
    return 'production';
  }

  return env;
};
